import React, {Component} from "react";
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
// import TourPrevIcon from "../../../assets/icons/tour-prev-icon.svg";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Tour from 'reactour'
import "./TourBase.css";
import { editTourMenu, editTourGroups,setStatusTourMenu, viewOnlyOnceTourMenu } from "../../../actions/TourAction";
class TourBase extends Component {
    _isMounted = false;

    constructor(props) {
      super(props)
  
      this.state = {
        isTourOpen: false
      }
      this.current = -1
    }

    disableBody = target => disableBodyScroll(target)
    enableBody = target => enableBodyScroll(target)
  
    componentWillUnmount() {
      this._isMounted = false;
    }
  
    componentDidMount(){
        const { onTourNotOpened, steps} = this.props
        // const seen = localStorage.getItem(`${this.props.identifier}_4${user._id}`) || false;
        const seen = steps.length === 0;;
        if(seen) {
          if(onTourNotOpened) onTourNotOpened();
          return;
        }
        this.setState({ 
          isTourOpen: true,
        });
    }

    handleSeenSteps = () => {
        const { user, steps, identifier } = this.props
        const stepsView = []
        if (steps && steps.length) {
          for (let i = 0; i < this.current; i++) {
            stepsView.push(steps[i].number)
          }
        }
        if (identifier === 'groups_tour') {
          this.props.editTourGroups(user._id, stepsView)
        }
        if (identifier === 'menu_tour') {
          if (steps && steps.length) {
            if (steps.length === stepsView.length) {
              this.props.setStatusTourMenu(true);
              this.props.viewOnlyOnceTourMenu(true);
            }  
          }
          this.props.editTourMenu(user._id, stepsView)
          // this.props.setStatusTourMenu(true)
        }
        this.setState({ isTourOpen: false })
    }

    handleBadgeContent = (current, total) => {
        const { intl } = this.props
        this.current = current
        return `${current} ${intl.formatMessage({ id: 'of' })} ${total}`
    }

    render() {
        const {
            isTourOpen
        } = this.state;
        const {
            steps,
            onRequestClose,
            onChangePage,
            onAfterOpen,
            onBeforeClose,
            identifier
        } = this.props;
        const savedColor = localStorage.getItem('primaryColor');
        const MenuIcon = (props) =>(
          <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5607 0.439332C12.1464 1.02511 12.1464 1.97484 11.5607 2.56062L3.62127 10.5L11.5607 18.4394C12.1464 19.0252 12.1464 19.9749 11.5607 20.5607C10.9749 21.1464 10.0252 21.1464 9.43938 20.5607L0.439333 11.5606C-0.146444 10.9749 -0.146444 10.0251 0.439333 9.43936L9.43938 0.439332C10.0252 -0.146444 10.9749 -0.146444 11.5607 0.439332Z" fill={props.fill}/>
          </svg>
        )
        return (
            <React.Fragment>
                <Tour
                    accentColor={savedColor}
                    badgeContent={this.handleBadgeContent}
                    getCurrentStep={(curr) => {
                        if (identifier && identifier === 'menu_tour') {
                          if(onChangePage) onChangePage(curr)
                        } else {
                          if(curr > 0){
                            if(onChangePage) onChangePage(curr)
                          }
                        }
                      }}
                    steps={steps}
                    rounded={5}
                    onAfterOpen={()=>{
                      if(onAfterOpen) onAfterOpen();
                      this.disableBody();
                    }}
                    onBeforeClose={()=>{
                      if(onBeforeClose) onBeforeClose();
                      this.enableBody();
                    }}
                    isOpen={isTourOpen}
                    maskSpace={20}
                    lastStepNextButton={<div className="tour-base-button"> Entendido </div>}
                    onRequestClose={()=>{
                        this.handleSeenSteps();
                        if(onRequestClose) onRequestClose();
                    }}
                    showNavigation={true}
                    // prevButton={<img src={TourPrevIcon} alt="prev" />}
                    prevButton={
                      <MenuIcon fill={savedColor} />
                    }
                    nextButton={<div className="tour-base-button"> Siguiente </div>}
                    />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
      user: state.authUser.user,
    }
  }
  
  const mapDispatchToProps = {
    editTourMenu,
    editTourGroups,
    setStatusTourMenu,
    viewOnlyOnceTourMenu
  }
  
  export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(TourBase)))
